import dayjs from 'dayjs'

export default class DateSerializer {
  private format: string 

  constructor(format = 'YYYY-MM-DD HH:mm:ss.SSS') {
    this.format = format
  }

  serialize(data: Record<string, unknown>) {
    const format = this.format

    function objTransfer(data: any): Record<any, unknown> {
      const result: Record<any, unknown> = {}
      Object.keys(data).forEach((key) => {
        const value = data[key]
        if (value instanceof Date || dayjs.isDayjs(value)) {
          result[key] = dayjs(value).format(format)
        } else if (value && value instanceof Object && !Array.isArray(value)) {
          result[key] = objTransfer(value)
        } else if (value && Array.isArray(value)) {
          result[key] = arrayTransfer(value)
        } else {
          result[key] = value
        }
      })
      return result
    }
    function arrayTransfer(data: Array<unknown>): Array<unknown> {
      return data.map((value) => {
        if (value instanceof Date || dayjs.isDayjs(value)) {
          return dayjs(value).format(format)
        } else if (value && value instanceof Object && !Array.isArray(value)) {
          return objTransfer(value)
        } else if (value && Array.isArray(value)) {
          return arrayTransfer(value)
        } else {
          return value
        }
      })
    }

    Object.keys(data).forEach((key) => {
      const value = data[key]
      if (value instanceof Date || dayjs.isDayjs(value)) {
        data[key] = dayjs(value).format(this.format)
      } else if (value && typeof value == 'object' && !Array.isArray(value)) {
        data[key] = objTransfer(value)
      } else if (value && Array.isArray(value)) {
        data[key] = arrayTransfer(value)
      }
    })
  }
}
